module.exports = __webpack_public_path__ + "static/media/asc-provider.6488a5de.svg";